module.exports = __webpack_public_path__ + "static/media/logos.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos.png
// module id = 886
// module chunks = 0